let wasm;

const cachedTextDecoder = (typeof TextDecoder !== 'undefined' ? new TextDecoder('utf-8', { ignoreBOM: true, fatal: true }) : { decode: () => { throw Error('TextDecoder not available') } } );

if (typeof TextDecoder !== 'undefined') { cachedTextDecoder.decode(); };

let cachedUint8ArrayMemory0 = null;

function getUint8ArrayMemory0() {
    if (cachedUint8ArrayMemory0 === null || cachedUint8ArrayMemory0.byteLength === 0) {
        cachedUint8ArrayMemory0 = new Uint8Array(wasm.memory.buffer);
    }
    return cachedUint8ArrayMemory0;
}

function getStringFromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return cachedTextDecoder.decode(getUint8ArrayMemory0().subarray(ptr, ptr + len));
}

const heap = new Array(128).fill(undefined);

heap.push(undefined, null, true, false);

let heap_next = heap.length;

function addHeapObject(obj) {
    if (heap_next === heap.length) heap.push(heap.length + 1);
    const idx = heap_next;
    heap_next = heap[idx];

    heap[idx] = obj;
    return idx;
}

function getObject(idx) { return heap[idx]; }

function dropObject(idx) {
    if (idx < 132) return;
    heap[idx] = heap_next;
    heap_next = idx;
}

function takeObject(idx) {
    const ret = getObject(idx);
    dropObject(idx);
    return ret;
}

function _assertClass(instance, klass) {
    if (!(instance instanceof klass)) {
        throw new Error(`expected instance of ${klass.name}`);
    }
    return instance.ptr;
}

let WASM_VECTOR_LEN = 0;

const cachedTextEncoder = (typeof TextEncoder !== 'undefined' ? new TextEncoder('utf-8') : { encode: () => { throw Error('TextEncoder not available') } } );

const encodeString = (typeof cachedTextEncoder.encodeInto === 'function'
    ? function (arg, view) {
    return cachedTextEncoder.encodeInto(arg, view);
}
    : function (arg, view) {
    const buf = cachedTextEncoder.encode(arg);
    view.set(buf);
    return {
        read: arg.length,
        written: buf.length
    };
});

function passStringToWasm0(arg, malloc, realloc) {

    if (realloc === undefined) {
        const buf = cachedTextEncoder.encode(arg);
        const ptr = malloc(buf.length, 1) >>> 0;
        getUint8ArrayMemory0().subarray(ptr, ptr + buf.length).set(buf);
        WASM_VECTOR_LEN = buf.length;
        return ptr;
    }

    let len = arg.length;
    let ptr = malloc(len, 1) >>> 0;

    const mem = getUint8ArrayMemory0();

    let offset = 0;

    for (; offset < len; offset++) {
        const code = arg.charCodeAt(offset);
        if (code > 0x7F) break;
        mem[ptr + offset] = code;
    }

    if (offset !== len) {
        if (offset !== 0) {
            arg = arg.slice(offset);
        }
        ptr = realloc(ptr, len, len = offset + arg.length * 3, 1) >>> 0;
        const view = getUint8ArrayMemory0().subarray(ptr + offset, ptr + len);
        const ret = encodeString(arg, view);

        offset += ret.written;
        ptr = realloc(ptr, len, offset, 1) >>> 0;
    }

    WASM_VECTOR_LEN = offset;
    return ptr;
}

let cachedDataViewMemory0 = null;

function getDataViewMemory0() {
    if (cachedDataViewMemory0 === null || cachedDataViewMemory0.buffer.detached === true || (cachedDataViewMemory0.buffer.detached === undefined && cachedDataViewMemory0.buffer !== wasm.memory.buffer)) {
        cachedDataViewMemory0 = new DataView(wasm.memory.buffer);
    }
    return cachedDataViewMemory0;
}

function passArrayJsValueToWasm0(array, malloc) {
    const ptr = malloc(array.length * 4, 4) >>> 0;
    const mem = getDataViewMemory0();
    for (let i = 0; i < array.length; i++) {
        mem.setUint32(ptr + 4 * i, addHeapObject(array[i]), true);
    }
    WASM_VECTOR_LEN = array.length;
    return ptr;
}

function getArrayJsValueFromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    const mem = getDataViewMemory0();
    const result = [];
    for (let i = ptr; i < ptr + 4 * len; i += 4) {
        result.push(takeObject(mem.getUint32(i, true)));
    }
    return result;
}

const BaseFlatMeshFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_baseflatmesh_free(ptr >>> 0, 1));
/**
*/
export class BaseFlatMesh {

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        BaseFlatMeshFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_baseflatmesh_free(ptr, 0);
    }
    /**
    * @returns {boolean}
    */
    get extruded() {
        const ret = wasm.__wbg_get_baseflatmesh_extruded(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set extruded(arg0) {
        wasm.__wbg_set_baseflatmesh_extruded(this.__wbg_ptr, arg0);
    }
    /**
    * @returns {boolean}
    */
    get is_mesh() {
        const ret = wasm.__wbg_get_baseflatmesh_is_mesh(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set is_mesh(arg0) {
        wasm.__wbg_set_baseflatmesh_is_mesh(this.__wbg_ptr, arg0);
    }
    /**
    * @returns {Vector3D}
    */
    get position() {
        const ret = wasm.__wbg_get_baseflatmesh_position(this.__wbg_ptr);
        return Vector3D.__wrap(ret);
    }
    /**
    * @param {Vector3D} arg0
    */
    set position(arg0) {
        _assertClass(arg0, Vector3D);
        var ptr0 = arg0.__destroy_into_raw();
        wasm.__wbg_set_baseflatmesh_position(this.__wbg_ptr, ptr0);
    }
    /**
    * @returns {Vector3D}
    */
    get rotation() {
        const ret = wasm.__wbg_get_baseflatmesh_rotation(this.__wbg_ptr);
        return Vector3D.__wrap(ret);
    }
    /**
    * @param {Vector3D} arg0
    */
    set rotation(arg0) {
        _assertClass(arg0, Vector3D);
        var ptr0 = arg0.__destroy_into_raw();
        wasm.__wbg_set_baseflatmesh_rotation(this.__wbg_ptr, ptr0);
    }
    /**
    * @returns {Vector3D}
    */
    get scale() {
        const ret = wasm.__wbg_get_baseflatmesh_scale(this.__wbg_ptr);
        return Vector3D.__wrap(ret);
    }
    /**
    * @param {Vector3D} arg0
    */
    set scale(arg0) {
        _assertClass(arg0, Vector3D);
        var ptr0 = arg0.__destroy_into_raw();
        wasm.__wbg_set_baseflatmesh_scale(this.__wbg_ptr, ptr0);
    }
    /**
    * @param {string} id
    */
    set id(id) {
        const ptr0 = passStringToWasm0(id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.baseflatmesh_set_id(this.__wbg_ptr, ptr0, len0);
    }
    /**
    * @returns {string}
    */
    get id() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.baseflatmesh_id(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    * @param {string} id
    */
    constructor(id) {
        const ptr0 = passStringToWasm0(id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.baseflatmesh_new(ptr0, len0);
        this.__wbg_ptr = ret >>> 0;
        BaseFlatMeshFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
    * @param {(Vector3D)[]} vertices
    */
    add_vertices(vertices) {
        const ptr0 = passArrayJsValueToWasm0(vertices, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.baseflatmesh_add_vertices(this.__wbg_ptr, ptr0, len0);
    }
    /**
    * @param {Vector3D} vertex
    */
    add_vertex(vertex) {
        _assertClass(vertex, Vector3D);
        var ptr0 = vertex.__destroy_into_raw();
        wasm.baseflatmesh_add_vertex(this.__wbg_ptr, ptr0);
    }
    /**
    * @returns {string}
    */
    triangulate() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.baseflatmesh_triangulate(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    * @returns {string}
    */
    get_buffer_flush() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.baseflatmesh_get_buffer_flush(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    */
    reset_mesh() {
        wasm.baseflatmesh_reset_mesh(this.__wbg_ptr);
    }
}

const BaseMeshFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_basemesh_free(ptr >>> 0, 1));
/**
*/
export class BaseMesh {

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        BaseMeshFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_basemesh_free(ptr, 0);
    }
    /**
    * @returns {boolean}
    */
    get is_from_extruded() {
        const ret = wasm.__wbg_get_basemesh_is_from_extruded(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set is_from_extruded(arg0) {
        wasm.__wbg_set_basemesh_is_from_extruded(this.__wbg_ptr, arg0);
    }
    /**
    * @returns {boolean}
    */
    get is_from_polygon() {
        const ret = wasm.__wbg_get_basemesh_is_from_polygon(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set is_from_polygon(arg0) {
        wasm.__wbg_set_basemesh_is_from_polygon(this.__wbg_ptr, arg0);
    }
    /**
    * @returns {Vector3D}
    */
    get position() {
        const ret = wasm.__wbg_get_basemesh_position(this.__wbg_ptr);
        return Vector3D.__wrap(ret);
    }
    /**
    * @param {Vector3D} arg0
    */
    set position(arg0) {
        _assertClass(arg0, Vector3D);
        var ptr0 = arg0.__destroy_into_raw();
        wasm.__wbg_set_basemesh_position(this.__wbg_ptr, ptr0);
    }
    /**
    * @returns {Vector3D}
    */
    get rotation() {
        const ret = wasm.__wbg_get_basemesh_rotation(this.__wbg_ptr);
        return Vector3D.__wrap(ret);
    }
    /**
    * @param {Vector3D} arg0
    */
    set rotation(arg0) {
        _assertClass(arg0, Vector3D);
        var ptr0 = arg0.__destroy_into_raw();
        wasm.__wbg_set_basemesh_rotation(this.__wbg_ptr, ptr0);
    }
    /**
    * @returns {Vector3D}
    */
    get scale() {
        const ret = wasm.__wbg_get_basemesh_scale(this.__wbg_ptr);
        return Vector3D.__wrap(ret);
    }
    /**
    * @param {Vector3D} arg0
    */
    set scale(arg0) {
        _assertClass(arg0, Vector3D);
        var ptr0 = arg0.__destroy_into_raw();
        wasm.__wbg_set_basemesh_scale(this.__wbg_ptr, ptr0);
    }
    /**
    * @param {string} id
    */
    set id(id) {
        const ptr0 = passStringToWasm0(id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.basemesh_set_id(this.__wbg_ptr, ptr0, len0);
    }
    /**
    * @returns {string}
    */
    get id() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.basemesh_id(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    * @param {string} id
    */
    constructor(id) {
        const ptr0 = passStringToWasm0(id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.basemesh_new(ptr0, len0);
        this.__wbg_ptr = ret >>> 0;
        BaseMeshFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
    *
    *   * Side view as of now
    *
    * @returns {string}
    */
    outline() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.basemesh_outline(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
}

const BasePolygonFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_basepolygon_free(ptr >>> 0, 1));
/**
*/
export class BasePolygon {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(BasePolygon.prototype);
        obj.__wbg_ptr = ptr;
        BasePolygonFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        BasePolygonFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_basepolygon_free(ptr, 0);
    }
    /**
    * @returns {boolean}
    */
    get extruded() {
        const ret = wasm.__wbg_get_basepolygon_extruded(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set extruded(arg0) {
        wasm.__wbg_set_basepolygon_extruded(this.__wbg_ptr, arg0);
    }
    /**
    * @returns {number}
    */
    get extruded_height() {
        const ret = wasm.__wbg_get_basepolygon_extruded_height(this.__wbg_ptr);
        return ret;
    }
    /**
    * @param {number} arg0
    */
    set extruded_height(arg0) {
        wasm.__wbg_set_basepolygon_extruded_height(this.__wbg_ptr, arg0);
    }
    /**
    * @returns {boolean}
    */
    get is_polygon() {
        const ret = wasm.__wbg_get_basepolygon_is_polygon(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set is_polygon(arg0) {
        wasm.__wbg_set_basepolygon_is_polygon(this.__wbg_ptr, arg0);
    }
    /**
    * @returns {Vector3D}
    */
    get position() {
        const ret = wasm.__wbg_get_basepolygon_position(this.__wbg_ptr);
        return Vector3D.__wrap(ret);
    }
    /**
    * @param {Vector3D} arg0
    */
    set position(arg0) {
        _assertClass(arg0, Vector3D);
        var ptr0 = arg0.__destroy_into_raw();
        wasm.__wbg_set_basepolygon_position(this.__wbg_ptr, ptr0);
    }
    /**
    * @returns {Vector3D}
    */
    get rotation() {
        const ret = wasm.__wbg_get_basepolygon_rotation(this.__wbg_ptr);
        return Vector3D.__wrap(ret);
    }
    /**
    * @param {Vector3D} arg0
    */
    set rotation(arg0) {
        _assertClass(arg0, Vector3D);
        var ptr0 = arg0.__destroy_into_raw();
        wasm.__wbg_set_basepolygon_rotation(this.__wbg_ptr, ptr0);
    }
    /**
    * @returns {Vector3D}
    */
    get scale() {
        const ret = wasm.__wbg_get_basepolygon_scale(this.__wbg_ptr);
        return Vector3D.__wrap(ret);
    }
    /**
    * @param {Vector3D} arg0
    */
    set scale(arg0) {
        _assertClass(arg0, Vector3D);
        var ptr0 = arg0.__destroy_into_raw();
        wasm.__wbg_set_basepolygon_scale(this.__wbg_ptr, ptr0);
    }
    /**
    * @param {string} id
    */
    set id(id) {
        const ptr0 = passStringToWasm0(id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.basepolygon_set_id(this.__wbg_ptr, ptr0, len0);
    }
    /**
    * @returns {string}
    */
    get id() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.basepolygon_id(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    * @param {string} id
    */
    constructor(id) {
        const ptr0 = passStringToWasm0(id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.basepolygon_new(ptr0, len0);
        this.__wbg_ptr = ret >>> 0;
        BasePolygonFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
    * @param {CircleArc} circle_arc
    * @returns {BasePolygon}
    */
    static new_with_circle(circle_arc) {
        _assertClass(circle_arc, CircleArc);
        var ptr0 = circle_arc.__destroy_into_raw();
        const ret = wasm.basepolygon_new_with_circle(ptr0);
        return BasePolygon.__wrap(ret);
    }
    /**
    * @param {OGRectangle} rectangle
    * @returns {BasePolygon}
    */
    static new_with_rectangle(rectangle) {
        _assertClass(rectangle, OGRectangle);
        var ptr0 = rectangle.__destroy_into_raw();
        const ret = wasm.basepolygon_new_with_rectangle(ptr0);
        return BasePolygon.__wrap(ret);
    }
    /**
    * @param {(Vector3D)[]} vertices
    */
    add_vertices(vertices) {
        const ptr0 = passArrayJsValueToWasm0(vertices, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.basepolygon_add_vertices(this.__wbg_ptr, ptr0, len0);
    }
    /**
    * @param {Vector3D} vertex
    */
    add_vertex(vertex) {
        _assertClass(vertex, Vector3D);
        var ptr0 = vertex.__destroy_into_raw();
        wasm.basepolygon_add_vertex(this.__wbg_ptr, ptr0);
    }
    /**
    * @param {(Vector3D)[]} holes
    */
    add_holes(holes) {
        const ptr0 = passArrayJsValueToWasm0(holes, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.basepolygon_add_holes(this.__wbg_ptr, ptr0, len0);
    }
    /**
    * @returns {string}
    */
    triangulate() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.basepolygon_triangulate(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    * @returns {string}
    */
    new_triangulate() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.basepolygon_new_triangulate(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    * @returns {string}
    */
    get_buffer_flush() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.basepolygon_get_buffer_flush(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    */
    clear_vertices() {
        wasm.basepolygon_clear_vertices(this.__wbg_ptr);
    }
    /**
    */
    reset_polygon() {
        wasm.basepolygon_reset_polygon(this.__wbg_ptr);
    }
    /**
    * @param {number} height
    * @returns {string}
    */
    extrude_by_height(height) {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.basepolygon_extrude_by_height(retptr, this.__wbg_ptr, height);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    * @returns {string}
    */
    get_outlines() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.basepolygon_get_outlines(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    * @returns {string}
    */
    get_geometry() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.basepolygon_get_geometry(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
}

const CircleArcFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_circlearc_free(ptr >>> 0, 1));
/**
*/
export class CircleArc {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(CircleArc.prototype);
        obj.__wbg_ptr = ptr;
        CircleArcFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        CircleArcFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_circlearc_free(ptr, 0);
    }
    /**
    * @param {string} id
    */
    set id(id) {
        const ptr0 = passStringToWasm0(id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.circlearc_set_id(this.__wbg_ptr, ptr0, len0);
    }
    /**
    * @returns {string}
    */
    get id() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.circlearc_id(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    * @param {string} id
    */
    constructor(id) {
        const ptr0 = passStringToWasm0(id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.circlearc_new(ptr0, len0);
        this.__wbg_ptr = ret >>> 0;
        CircleArcFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
    * @returns {CircleArc}
    */
    clone() {
        const ret = wasm.circlearc_clone(this.__wbg_ptr);
        return CircleArc.__wrap(ret);
    }
    /**
    * @param {Vector3D} center
    * @param {number} radius
    * @param {number} start_angle
    * @param {number} end_angle
    * @param {number} segments
    */
    set_config(center, radius, start_angle, end_angle, segments) {
        _assertClass(center, Vector3D);
        var ptr0 = center.__destroy_into_raw();
        wasm.circlearc_set_config(this.__wbg_ptr, ptr0, radius, start_angle, end_angle, segments);
    }
    /**
    */
    generate_points() {
        wasm.circlearc_generate_points(this.__wbg_ptr);
    }
    /**
    * @param {number} radius
    */
    update_radius(radius) {
        wasm.circlearc_update_radius(this.__wbg_ptr, radius);
    }
    /**
    * @param {Vector3D} center
    */
    update_center(center) {
        _assertClass(center, Vector3D);
        var ptr0 = center.__destroy_into_raw();
        wasm.circlearc_update_center(this.__wbg_ptr, ptr0);
    }
    /**
    */
    dispose_points() {
        wasm.circlearc_destroy(this.__wbg_ptr);
    }
    /**
    */
    destroy() {
        wasm.circlearc_destroy(this.__wbg_ptr);
    }
    /**
    * @returns {string}
    */
    get_points() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.circlearc_get_points(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    * @returns {(Vector3D)[]}
    */
    get_raw_points() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.circlearc_get_raw_points(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayJsValueFromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 4, 4);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}

const ColorFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_color_free(ptr >>> 0, 1));
/**
*/
export class Color {

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        ColorFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_color_free(ptr, 0);
    }
    /**
    * @param {string} hex
    */
    constructor(hex) {
        const ptr0 = passStringToWasm0(hex, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.color_new(ptr0, len0);
        this.__wbg_ptr = ret >>> 0;
        ColorFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
    * @returns {ColorRGB}
    */
    to_rgba() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.color_to_rgba(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return ColorRGB.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}

const ColorRGBFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_colorrgb_free(ptr >>> 0, 1));
/**
*/
export class ColorRGB {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(ColorRGB.prototype);
        obj.__wbg_ptr = ptr;
        ColorRGBFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        ColorRGBFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_colorrgb_free(ptr, 0);
    }
    /**
    * @returns {number}
    */
    get r() {
        const ret = wasm.__wbg_get_colorrgb_r(this.__wbg_ptr);
        return ret;
    }
    /**
    * @param {number} arg0
    */
    set r(arg0) {
        wasm.__wbg_set_colorrgb_r(this.__wbg_ptr, arg0);
    }
    /**
    * @returns {number}
    */
    get g() {
        const ret = wasm.__wbg_get_colorrgb_g(this.__wbg_ptr);
        return ret;
    }
    /**
    * @param {number} arg0
    */
    set g(arg0) {
        wasm.__wbg_set_colorrgb_g(this.__wbg_ptr, arg0);
    }
    /**
    * @returns {number}
    */
    get b() {
        const ret = wasm.__wbg_get_colorrgb_b(this.__wbg_ptr);
        return ret;
    }
    /**
    * @param {number} arg0
    */
    set b(arg0) {
        wasm.__wbg_set_colorrgb_b(this.__wbg_ptr, arg0);
    }
    /**
    * @param {number} r
    * @param {number} g
    * @param {number} b
    */
    constructor(r, g, b) {
        const ret = wasm.colorrgb_new(r, g, b);
        this.__wbg_ptr = ret >>> 0;
        ColorRGBFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
    * @returns {string}
    */
    to_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.colorrgb_to_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
}

const Matrix3DFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_matrix3d_free(ptr >>> 0, 1));
/**
*/
export class Matrix3D {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(Matrix3D.prototype);
        obj.__wbg_ptr = ptr;
        Matrix3DFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        Matrix3DFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_matrix3d_free(ptr, 0);
    }
    /**
    * @returns {number}
    */
    get m11() {
        const ret = wasm.__wbg_get_matrix3d_m11(this.__wbg_ptr);
        return ret;
    }
    /**
    * @param {number} arg0
    */
    set m11(arg0) {
        wasm.__wbg_set_matrix3d_m11(this.__wbg_ptr, arg0);
    }
    /**
    * @returns {number}
    */
    get m12() {
        const ret = wasm.__wbg_get_matrix3d_m12(this.__wbg_ptr);
        return ret;
    }
    /**
    * @param {number} arg0
    */
    set m12(arg0) {
        wasm.__wbg_set_matrix3d_m12(this.__wbg_ptr, arg0);
    }
    /**
    * @returns {number}
    */
    get m13() {
        const ret = wasm.__wbg_get_matrix3d_m13(this.__wbg_ptr);
        return ret;
    }
    /**
    * @param {number} arg0
    */
    set m13(arg0) {
        wasm.__wbg_set_matrix3d_m13(this.__wbg_ptr, arg0);
    }
    /**
    * @returns {number}
    */
    get m21() {
        const ret = wasm.__wbg_get_matrix3d_m21(this.__wbg_ptr);
        return ret;
    }
    /**
    * @param {number} arg0
    */
    set m21(arg0) {
        wasm.__wbg_set_matrix3d_m21(this.__wbg_ptr, arg0);
    }
    /**
    * @returns {number}
    */
    get m22() {
        const ret = wasm.__wbg_get_matrix3d_m22(this.__wbg_ptr);
        return ret;
    }
    /**
    * @param {number} arg0
    */
    set m22(arg0) {
        wasm.__wbg_set_matrix3d_m22(this.__wbg_ptr, arg0);
    }
    /**
    * @returns {number}
    */
    get m23() {
        const ret = wasm.__wbg_get_matrix3d_m23(this.__wbg_ptr);
        return ret;
    }
    /**
    * @param {number} arg0
    */
    set m23(arg0) {
        wasm.__wbg_set_matrix3d_m23(this.__wbg_ptr, arg0);
    }
    /**
    * @returns {number}
    */
    get m31() {
        const ret = wasm.__wbg_get_matrix3d_m31(this.__wbg_ptr);
        return ret;
    }
    /**
    * @param {number} arg0
    */
    set m31(arg0) {
        wasm.__wbg_set_matrix3d_m31(this.__wbg_ptr, arg0);
    }
    /**
    * @returns {number}
    */
    get m32() {
        const ret = wasm.__wbg_get_matrix3d_m32(this.__wbg_ptr);
        return ret;
    }
    /**
    * @param {number} arg0
    */
    set m32(arg0) {
        wasm.__wbg_set_matrix3d_m32(this.__wbg_ptr, arg0);
    }
    /**
    * @returns {number}
    */
    get m33() {
        const ret = wasm.__wbg_get_matrix3d_m33(this.__wbg_ptr);
        return ret;
    }
    /**
    * @param {number} arg0
    */
    set m33(arg0) {
        wasm.__wbg_set_matrix3d_m33(this.__wbg_ptr, arg0);
    }
    /**
    * @param {number} m11
    * @param {number} m12
    * @param {number} m13
    * @param {number} m21
    * @param {number} m22
    * @param {number} m23
    * @param {number} m31
    * @param {number} m32
    * @param {number} m33
    */
    constructor(m11, m12, m13, m21, m22, m23, m31, m32, m33) {
        const ret = wasm.matrix3d_set(m11, m12, m13, m21, m22, m23, m31, m32, m33);
        this.__wbg_ptr = ret >>> 0;
        Matrix3DFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
    * @param {Matrix3D} other
    * @returns {Matrix3D}
    */
    add(other) {
        _assertClass(other, Matrix3D);
        const ret = wasm.matrix3d_add(this.__wbg_ptr, other.__wbg_ptr);
        return Matrix3D.__wrap(ret);
    }
    /**
    * @param {Matrix3D} other
    * @returns {Matrix3D}
    */
    subtract(other) {
        _assertClass(other, Matrix3D);
        const ret = wasm.matrix3d_subtract(this.__wbg_ptr, other.__wbg_ptr);
        return Matrix3D.__wrap(ret);
    }
}

const OGCylinderFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_ogcylinder_free(ptr >>> 0, 1));
/**
*/
export class OGCylinder {

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        OGCylinderFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_ogcylinder_free(ptr, 0);
    }
    /**
    * @param {string} id
    */
    set id(id) {
        const ptr0 = passStringToWasm0(id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.ogcylinder_set_id(this.__wbg_ptr, ptr0, len0);
    }
    /**
    * @returns {string}
    */
    get id() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.ogcylinder_id(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    * @param {string} id
    */
    constructor(id) {
        const ptr0 = passStringToWasm0(id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.ogcylinder_new(ptr0, len0);
        this.__wbg_ptr = ret >>> 0;
        OGCylinderFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
    * @param {Vector3D} center
    * @param {number} radius
    * @param {number} height
    * @param {number} angle
    * @param {number} segments
    */
    set_config(center, radius, height, angle, segments) {
        _assertClass(center, Vector3D);
        var ptr0 = center.__destroy_into_raw();
        wasm.ogcylinder_set_config(this.__wbg_ptr, ptr0, radius, height, angle, segments);
    }
    /**
    */
    generate_geometry() {
        wasm.ogcylinder_generate_geometry(this.__wbg_ptr);
    }
    /**
    * @returns {string}
    */
    get_geometry() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.ogcylinder_get_geometry(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    */
    discard_geometry() {
        wasm.ogcylinder_discard_geometry(this.__wbg_ptr);
    }
    /**
    * @returns {string}
    */
    outline_edges() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.ogcylinder_outline_edges(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    * @returns {string}
    */
    get_brep_dump() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.ogcylinder_get_brep_dump(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
}

const OGPolyLineFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_ogpolyline_free(ptr >>> 0, 1));
/**
*/
export class OGPolyLine {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(OGPolyLine.prototype);
        obj.__wbg_ptr = ptr;
        OGPolyLineFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        OGPolyLineFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_ogpolyline_free(ptr, 0);
    }
    /**
    * @param {string} id
    */
    set id(id) {
        const ptr0 = passStringToWasm0(id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.ogpolyline_set_id(this.__wbg_ptr, ptr0, len0);
    }
    /**
    * @returns {string}
    */
    get id() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.ogpolyline_id(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    * @param {string} id
    */
    constructor(id) {
        const ptr0 = passStringToWasm0(id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.ogpolyline_new(ptr0, len0);
        this.__wbg_ptr = ret >>> 0;
        OGPolyLineFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
    * @returns {OGPolyLine}
    */
    clone() {
        const ret = wasm.ogpolyline_clone(this.__wbg_ptr);
        return OGPolyLine.__wrap(ret);
    }
    /**
    * @param {Vector3D} translation
    */
    translate(translation) {
        _assertClass(translation, Vector3D);
        var ptr0 = translation.__destroy_into_raw();
        wasm.ogpolyline_translate(this.__wbg_ptr, ptr0);
    }
    /**
    * @param {Vector3D} position
    */
    set_position(position) {
        _assertClass(position, Vector3D);
        var ptr0 = position.__destroy_into_raw();
        wasm.ogpolyline_set_position(this.__wbg_ptr, ptr0);
    }
    /**
    * @param {(Vector3D)[]} points
    */
    add_multiple_points(points) {
        const ptr0 = passArrayJsValueToWasm0(points, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.ogpolyline_add_multiple_points(this.__wbg_ptr, ptr0, len0);
    }
    /**
    * @param {Vector3D} point
    */
    add_point(point) {
        _assertClass(point, Vector3D);
        var ptr0 = point.__destroy_into_raw();
        wasm.ogpolyline_add_point(this.__wbg_ptr, ptr0);
    }
    /**
    * @returns {string}
    */
    get_points() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.ogpolyline_get_points(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    * @returns {(Vector3D)[]}
    */
    get_raw_points() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.ogpolyline_get_raw_points(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayJsValueFromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 4, 4);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {boolean}
    */
    is_closed() {
        const ret = wasm.ogpolyline_is_closed(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
    */
    check_closed_test() {
        wasm.ogpolyline_check_closed_test(this.__wbg_ptr);
    }
    /**
    */
    generate_brep() {
        wasm.ogpolyline_generate_brep(this.__wbg_ptr);
    }
    /**
    * @returns {string}
    */
    get_brep_data() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.ogpolyline_get_brep_data(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    * @param {number} distance
    * @returns {string}
    */
    get_offset(distance) {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.ogpolyline_get_offset(retptr, this.__wbg_ptr, distance);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    * @param {Vector3D} point_a
    * @param {Vector3D} point_b
    * @param {Vector3D} point_c
    * @param {Vector3D} point_d
    * @returns {Vector3D | undefined}
    */
    static calculate_2D_interesection(point_a, point_b, point_c, point_d) {
        _assertClass(point_a, Vector3D);
        _assertClass(point_b, Vector3D);
        _assertClass(point_c, Vector3D);
        _assertClass(point_d, Vector3D);
        const ret = wasm.ogpolyline_calculate_2D_interesection(point_a.__wbg_ptr, point_b.__wbg_ptr, point_c.__wbg_ptr, point_d.__wbg_ptr);
        return ret === 0 ? undefined : Vector3D.__wrap(ret);
    }
}

const OGPolygonFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_ogpolygon_free(ptr >>> 0, 1));
/**
*/
export class OGPolygon {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(OGPolygon.prototype);
        obj.__wbg_ptr = ptr;
        OGPolygonFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        OGPolygonFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_ogpolygon_free(ptr, 0);
    }
    /**
    * @returns {boolean}
    */
    get extruded() {
        const ret = wasm.__wbg_get_ogpolygon_extruded(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set extruded(arg0) {
        wasm.__wbg_set_ogpolygon_extruded(this.__wbg_ptr, arg0);
    }
    /**
    * @returns {number}
    */
    get extruded_height() {
        const ret = wasm.__wbg_get_ogpolygon_extruded_height(this.__wbg_ptr);
        return ret;
    }
    /**
    * @param {number} arg0
    */
    set extruded_height(arg0) {
        wasm.__wbg_set_ogpolygon_extruded_height(this.__wbg_ptr, arg0);
    }
    /**
    * @returns {boolean}
    */
    get is_polygon() {
        const ret = wasm.__wbg_get_ogpolygon_is_polygon(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set is_polygon(arg0) {
        wasm.__wbg_set_ogpolygon_is_polygon(this.__wbg_ptr, arg0);
    }
    /**
    * @returns {Vector3D}
    */
    get position() {
        const ret = wasm.__wbg_get_ogpolygon_position(this.__wbg_ptr);
        return Vector3D.__wrap(ret);
    }
    /**
    * @param {Vector3D} arg0
    */
    set position(arg0) {
        _assertClass(arg0, Vector3D);
        var ptr0 = arg0.__destroy_into_raw();
        wasm.__wbg_set_ogpolygon_position(this.__wbg_ptr, ptr0);
    }
    /**
    * @returns {Vector3D}
    */
    get rotation() {
        const ret = wasm.__wbg_get_ogpolygon_rotation(this.__wbg_ptr);
        return Vector3D.__wrap(ret);
    }
    /**
    * @param {Vector3D} arg0
    */
    set rotation(arg0) {
        _assertClass(arg0, Vector3D);
        var ptr0 = arg0.__destroy_into_raw();
        wasm.__wbg_set_ogpolygon_rotation(this.__wbg_ptr, ptr0);
    }
    /**
    * @returns {Vector3D}
    */
    get scale() {
        const ret = wasm.__wbg_get_ogpolygon_scale(this.__wbg_ptr);
        return Vector3D.__wrap(ret);
    }
    /**
    * @param {Vector3D} arg0
    */
    set scale(arg0) {
        _assertClass(arg0, Vector3D);
        var ptr0 = arg0.__destroy_into_raw();
        wasm.__wbg_set_ogpolygon_scale(this.__wbg_ptr, ptr0);
    }
    /**
    * @param {string} id
    */
    set id(id) {
        const ptr0 = passStringToWasm0(id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.ogpolygon_set_id(this.__wbg_ptr, ptr0, len0);
    }
    /**
    * @returns {string}
    */
    get id() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.ogpolygon_id(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    * @param {string} id
    */
    constructor(id) {
        const ptr0 = passStringToWasm0(id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.ogpolygon_new(ptr0, len0);
        this.__wbg_ptr = ret >>> 0;
        OGPolygonFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
    * @param {Vector3D} translation
    */
    translate(translation) {
        _assertClass(translation, Vector3D);
        var ptr0 = translation.__destroy_into_raw();
        wasm.ogpolygon_translate(this.__wbg_ptr, ptr0);
    }
    /**
    * @param {CircleArc} circle_arc
    * @returns {OGPolygon}
    */
    static new_with_circle(circle_arc) {
        _assertClass(circle_arc, CircleArc);
        var ptr0 = circle_arc.__destroy_into_raw();
        const ret = wasm.ogpolygon_new_with_circle(ptr0);
        return OGPolygon.__wrap(ret);
    }
    /**
    * @param {OGRectangle} rectangle
    * @returns {OGPolygon}
    */
    static new_with_rectangle(rectangle) {
        _assertClass(rectangle, OGRectangle);
        var ptr0 = rectangle.__destroy_into_raw();
        const ret = wasm.ogpolygon_new_with_rectangle(ptr0);
        return OGPolygon.__wrap(ret);
    }
    /**
    * @param {(Vector3D)[]} vertices
    */
    add_vertices(vertices) {
        const ptr0 = passArrayJsValueToWasm0(vertices, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.ogpolygon_add_vertices(this.__wbg_ptr, ptr0, len0);
    }
    /**
    * @param {Vector3D} vertex
    */
    add_vertex(vertex) {
        _assertClass(vertex, Vector3D);
        var ptr0 = vertex.__destroy_into_raw();
        wasm.ogpolygon_add_vertex(this.__wbg_ptr, ptr0);
    }
    /**
    * @param {(Vector3D)[]} holes
    */
    add_holes(holes) {
        const ptr0 = passArrayJsValueToWasm0(holes, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.ogpolygon_add_holes(this.__wbg_ptr, ptr0, len0);
    }
    /**
    * @returns {string}
    */
    triangulate() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.ogpolygon_triangulate(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    * @param {boolean} is_ccw
    * @returns {string}
    */
    triangulate_with_holes_variable_geometry(is_ccw) {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.ogpolygon_triangulate_with_holes_variable_geometry(retptr, this.__wbg_ptr, is_ccw);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    * @returns {string}
    */
    triangulate_with_holes() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.ogpolygon_triangulate_with_holes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    * @returns {string}
    */
    get_buffer_flush() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.ogpolygon_get_buffer_flush(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    */
    clear_buffer() {
        wasm.ogpolygon_clear_buffer(this.__wbg_ptr);
    }
    /**
    */
    clear_vertices() {
        wasm.ogpolygon_clear_vertices(this.__wbg_ptr);
    }
    /**
    */
    reset_polygon() {
        wasm.ogpolygon_reset_polygon(this.__wbg_ptr);
    }
    /**
    * @param {number} height
    * @returns {string}
    */
    extrude_by_height_with_holes(height) {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.ogpolygon_extrude_by_height_with_holes(retptr, this.__wbg_ptr, height);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    * @param {number} height
    * @returns {string}
    */
    extrude_by_height(height) {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.ogpolygon_extrude_by_height(retptr, this.__wbg_ptr, height);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    * @returns {string}
    */
    get_outlines() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.ogpolygon_get_outlines(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    * @returns {string}
    */
    get_geometry() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.ogpolygon_get_geometry(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    * @returns {string}
    */
    get_brep_data() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.ogpolygon_get_brep_data(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    * @returns {string}
    */
    outline_edges() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.ogpolygon_outline_edges(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    * @returns {string}
    */
    binary_tree() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.ogpolygon_binary_tree(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
}

const OGRectangleFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_ogrectangle_free(ptr >>> 0, 1));
/**
*/
export class OGRectangle {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(OGRectangle.prototype);
        obj.__wbg_ptr = ptr;
        OGRectangleFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        OGRectangleFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_ogrectangle_free(ptr, 0);
    }
    /**
    * @param {string} id
    */
    set id(id) {
        const ptr0 = passStringToWasm0(id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.ogrectangle_set_id(this.__wbg_ptr, ptr0, len0);
    }
    /**
    * @returns {string}
    */
    get id() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.ogrectangle_id(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    * @param {string} id
    */
    constructor(id) {
        const ptr0 = passStringToWasm0(id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.ogrectangle_new(ptr0, len0);
        this.__wbg_ptr = ret >>> 0;
        OGRectangleFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
    * @returns {OGRectangle}
    */
    clone() {
        const ret = wasm.ogrectangle_clone(this.__wbg_ptr);
        return OGRectangle.__wrap(ret);
    }
    /**
    * @param {Vector3D} center
    * @param {number} width
    * @param {number} breadth
    */
    set_config(center, width, breadth) {
        _assertClass(center, Vector3D);
        var ptr0 = center.__destroy_into_raw();
        wasm.ogrectangle_set_config(this.__wbg_ptr, ptr0, width, breadth);
    }
    /**
    */
    generate_points() {
        wasm.ogrectangle_generate_points(this.__wbg_ptr);
    }
    /**
    * @param {number} width
    */
    update_width(width) {
        wasm.ogrectangle_update_width(this.__wbg_ptr, width);
    }
    /**
    * @param {number} breadth
    */
    update_breadth(breadth) {
        wasm.ogrectangle_update_breadth(this.__wbg_ptr, breadth);
    }
    /**
    * @param {Vector3D} center
    */
    update_center(center) {
        _assertClass(center, Vector3D);
        var ptr0 = center.__destroy_into_raw();
        wasm.ogrectangle_update_center(this.__wbg_ptr, ptr0);
    }
    /**
    */
    dispose_points() {
        wasm.ogrectangle_destroy(this.__wbg_ptr);
    }
    /**
    */
    destroy() {
        wasm.ogrectangle_destroy(this.__wbg_ptr);
    }
    /**
    * @returns {string}
    */
    get_points() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.ogrectangle_get_points(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    * @returns {(Vector3D)[]}
    */
    get_raw_points() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.ogrectangle_get_raw_points(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayJsValueFromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 4, 4);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}

const OGSimpleLineFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_ogsimpleline_free(ptr >>> 0, 1));
/**
*/
export class OGSimpleLine {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(OGSimpleLine.prototype);
        obj.__wbg_ptr = ptr;
        OGSimpleLineFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        OGSimpleLineFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_ogsimpleline_free(ptr, 0);
    }
    /**
    * @param {string} id
    */
    set id(id) {
        const ptr0 = passStringToWasm0(id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.ogsimpleline_set_id(this.__wbg_ptr, ptr0, len0);
    }
    /**
    * @returns {string}
    */
    get id() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.ogsimpleline_id(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    * @param {string} id
    */
    constructor(id) {
        const ptr0 = passStringToWasm0(id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.ogsimpleline_new(ptr0, len0);
        this.__wbg_ptr = ret >>> 0;
        OGSimpleLineFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
    * @returns {OGSimpleLine}
    */
    clone() {
        const ret = wasm.ogsimpleline_clone(this.__wbg_ptr);
        return OGSimpleLine.__wrap(ret);
    }
    /**
    * @param {Vector3D} start
    * @param {Vector3D} end
    */
    set_config(start, end) {
        _assertClass(start, Vector3D);
        var ptr0 = start.__destroy_into_raw();
        _assertClass(end, Vector3D);
        var ptr1 = end.__destroy_into_raw();
        wasm.ogsimpleline_set_config(this.__wbg_ptr, ptr0, ptr1);
    }
    /**
    */
    dispose_points() {
        wasm.ogsimpleline_destroy(this.__wbg_ptr);
    }
    /**
    */
    destroy() {
        wasm.ogsimpleline_destroy(this.__wbg_ptr);
    }
    /**
    * @returns {string}
    */
    get_points() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.ogsimpleline_get_points(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    * @returns {(Vector3D)[]}
    */
    get_raw_points() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.ogsimpleline_get_raw_points(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayJsValueFromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 4, 4);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}

const Vector3DFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_vector3d_free(ptr >>> 0, 1));
/**
*/
export class Vector3D {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(Vector3D.prototype);
        obj.__wbg_ptr = ptr;
        Vector3DFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    static __unwrap(jsValue) {
        if (!(jsValue instanceof Vector3D)) {
            return 0;
        }
        return jsValue.__destroy_into_raw();
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        Vector3DFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_vector3d_free(ptr, 0);
    }
    /**
    * @returns {number}
    */
    get x() {
        const ret = wasm.__wbg_get_matrix3d_m11(this.__wbg_ptr);
        return ret;
    }
    /**
    * @param {number} arg0
    */
    set x(arg0) {
        wasm.__wbg_set_matrix3d_m11(this.__wbg_ptr, arg0);
    }
    /**
    * @returns {number}
    */
    get y() {
        const ret = wasm.__wbg_get_matrix3d_m12(this.__wbg_ptr);
        return ret;
    }
    /**
    * @param {number} arg0
    */
    set y(arg0) {
        wasm.__wbg_set_matrix3d_m12(this.__wbg_ptr, arg0);
    }
    /**
    * @returns {number}
    */
    get z() {
        const ret = wasm.__wbg_get_matrix3d_m13(this.__wbg_ptr);
        return ret;
    }
    /**
    * @param {number} arg0
    */
    set z(arg0) {
        wasm.__wbg_set_matrix3d_m13(this.__wbg_ptr, arg0);
    }
    /**
    * @param {number} x
    * @param {number} y
    * @param {number} z
    */
    constructor(x, y, z) {
        const ret = wasm.vector3d_create(x, y, z);
        this.__wbg_ptr = ret >>> 0;
        Vector3DFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
    * @param {number} x
    * @param {number} y
    * @param {number} z
    */
    update(x, y, z) {
        wasm.vector3d_update(this.__wbg_ptr, x, y, z);
    }
    /**
    * @param {Vector3D} other
    * @returns {Vector3D}
    */
    add(other) {
        _assertClass(other, Vector3D);
        const ret = wasm.vector3d_add(this.__wbg_ptr, other.__wbg_ptr);
        return Vector3D.__wrap(ret);
    }
    /**
    * @param {Vector3D} other
    * @returns {Vector3D}
    */
    subtract(other) {
        _assertClass(other, Vector3D);
        const ret = wasm.vector3d_subtract(this.__wbg_ptr, other.__wbg_ptr);
        return Vector3D.__wrap(ret);
    }
    /**
    * @param {number} scalar
    * @returns {Vector3D}
    */
    add_scalar(scalar) {
        const ret = wasm.vector3d_add_scalar(this.__wbg_ptr, scalar);
        return Vector3D.__wrap(ret);
    }
    /**
    * @param {number} scalar
    * @returns {Vector3D}
    */
    subtract_scalar(scalar) {
        const ret = wasm.vector3d_subtract_scalar(this.__wbg_ptr, scalar);
        return Vector3D.__wrap(ret);
    }
    /**
    * @param {number} height
    * @param {Vector3D} up_vector
    * @returns {Vector3D}
    */
    add_extrude_in_up(height, up_vector) {
        _assertClass(up_vector, Vector3D);
        var ptr0 = up_vector.__destroy_into_raw();
        const ret = wasm.vector3d_add_extrude_in_up(this.__wbg_ptr, height, ptr0);
        return Vector3D.__wrap(ret);
    }
    /**
    * @param {Vector3D} other
    * @returns {Vector3D}
    */
    cross(other) {
        _assertClass(other, Vector3D);
        const ret = wasm.vector3d_cross(this.__wbg_ptr, other.__wbg_ptr);
        return Vector3D.__wrap(ret);
    }
    /**
    * @param {Vector3D} other
    * @returns {number}
    */
    dot(other) {
        _assertClass(other, Vector3D);
        const ret = wasm.vector3d_dot(this.__wbg_ptr, other.__wbg_ptr);
        return ret;
    }
    /**
    * @returns {Vector3D}
    */
    clone() {
        const ret = wasm.vector3d_clone(this.__wbg_ptr);
        return Vector3D.__wrap(ret);
    }
    /**
    * @returns {number}
    */
    length_squared() {
        const ret = wasm.vector3d_length_squared(this.__wbg_ptr);
        return ret;
    }
    /**
    * @returns {number}
    */
    magnitude() {
        const ret = wasm.vector3d_magnitude(this.__wbg_ptr);
        return ret;
    }
    /**
    * @returns {Vector3D}
    */
    normalize() {
        const ret = wasm.vector3d_normalize(this.__wbg_ptr);
        return Vector3D.__wrap(ret);
    }
    /**
    * @param {number} scalar
    * @returns {Vector3D}
    */
    multiply(scalar) {
        const ret = wasm.vector3d_multiply(this.__wbg_ptr, scalar);
        return Vector3D.__wrap(ret);
    }
    /**
    * @param {Vector3D} other
    * @returns {number}
    */
    distance_to(other) {
        _assertClass(other, Vector3D);
        const ret = wasm.vector3d_distance_to(this.__wbg_ptr, other.__wbg_ptr);
        return ret;
    }
}

async function __wbg_load(module, imports) {
    if (typeof Response === 'function' && module instanceof Response) {
        if (typeof WebAssembly.instantiateStreaming === 'function') {
            try {
                return await WebAssembly.instantiateStreaming(module, imports);

            } catch (e) {
                if (module.headers.get('Content-Type') != 'application/wasm') {
                    console.warn("`WebAssembly.instantiateStreaming` failed because your server does not serve wasm with `application/wasm` MIME type. Falling back to `WebAssembly.instantiate` which is slower. Original error:\n", e);

                } else {
                    throw e;
                }
            }
        }

        const bytes = await module.arrayBuffer();
        return await WebAssembly.instantiate(bytes, imports);

    } else {
        const instance = await WebAssembly.instantiate(module, imports);

        if (instance instanceof WebAssembly.Instance) {
            return { instance, module };

        } else {
            return instance;
        }
    }
}

function __wbg_get_imports() {
    const imports = {};
    imports.wbg = {};
    imports.wbg.__wbindgen_string_new = function(arg0, arg1) {
        const ret = getStringFromWasm0(arg0, arg1);
        return addHeapObject(ret);
    };
    imports.wbg.__wbindgen_object_drop_ref = function(arg0) {
        takeObject(arg0);
    };
    imports.wbg.__wbg_vector3d_new = function(arg0) {
        const ret = Vector3D.__wrap(arg0);
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_vector3d_unwrap = function(arg0) {
        const ret = Vector3D.__unwrap(takeObject(arg0));
        return ret;
    };
    imports.wbg.__wbg_log_b103404cc5920657 = function(arg0) {
        console.log(getObject(arg0));
    };
    imports.wbg.__wbindgen_throw = function(arg0, arg1) {
        throw new Error(getStringFromWasm0(arg0, arg1));
    };

    return imports;
}

function __wbg_init_memory(imports, memory) {

}

function __wbg_finalize_init(instance, module) {
    wasm = instance.exports;
    __wbg_init.__wbindgen_wasm_module = module;
    cachedDataViewMemory0 = null;
    cachedUint8ArrayMemory0 = null;



    return wasm;
}

function initSync(module) {
    if (wasm !== undefined) return wasm;


    if (typeof module !== 'undefined' && Object.getPrototypeOf(module) === Object.prototype)
    ({module} = module)
    else
    console.warn('using deprecated parameters for `initSync()`; pass a single object instead')

    const imports = __wbg_get_imports();

    __wbg_init_memory(imports);

    if (!(module instanceof WebAssembly.Module)) {
        module = new WebAssembly.Module(module);
    }

    const instance = new WebAssembly.Instance(module, imports);

    return __wbg_finalize_init(instance, module);
}

async function __wbg_init(module_or_path) {
    if (wasm !== undefined) return wasm;


    if (typeof module_or_path !== 'undefined' && Object.getPrototypeOf(module_or_path) === Object.prototype)
    ({module_or_path} = module_or_path)
    else
    console.warn('using deprecated parameters for the initialization function; pass a single object instead')

    if (typeof module_or_path === 'undefined') {
        module_or_path = new URL('opengeometry_bg.wasm', import.meta.url);
    }
    const imports = __wbg_get_imports();

    if (typeof module_or_path === 'string' || (typeof Request === 'function' && module_or_path instanceof Request) || (typeof URL === 'function' && module_or_path instanceof URL)) {
        module_or_path = fetch(module_or_path);
    }

    __wbg_init_memory(imports);

    const { instance, module } = await __wbg_load(await module_or_path, imports);

    return __wbg_finalize_init(instance, module);
}

export { initSync };
export default __wbg_init;
